export default {
  enabled: false,
  mockAuthentication: true,
  mockApi: true,
  delay: 1500,
  mockedUser: {
    userId: 'foo@statoil.com',
    uniqueId: 'foo@statoil.com',
    displayableId: 'John Smith',
    familyName: 'Smith',
    givenName: 'John',
    identityProvider: 'https://sts.fake.com',
    ipaddr: '127.0.0.1',
  },
};
